import { Card } from '@/components/ui/card';
import type { FormattedStats } from '../../lib/types';

interface ServiceSummaryProps {
  stats: Partial<FormattedStats>;
}

export function ServiceSummary({ stats }: ServiceSummaryProps) {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Service Summary</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h4 className="font-medium mb-2">Key Metrics</h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Net Balance:</span>
              <span className={`font-medium ${stats.netBalancePositive ? 'text-green-600' : 'text-red-600'}`}>
                {stats.netBalance}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Utilization Rate:</span>
              <span className="font-medium">{stats.utilizationRate}</span>
            </div>
          </div>
        </div>
        <div>
          <h4 className="font-medium mb-2">Service Coverage</h4>
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-muted-foreground">Active Partners:</span>
              <span className="font-medium">{stats.activePartners}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-muted-foreground">Product Types:</span>
              <span className="font-medium">{stats.productTypes}</span>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}
